import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://uvprinnqkjbdpmabiukx.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV2cHJpbm5xa2piZHBtYWJpdWt4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU3NTgxMTksImV4cCI6MjA5MTMzNDExOX0.WBswvOrn2wfokHVbrklZ61Z3aCc3WI3OkXJTca54gaI';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
